import * as React from 'react';
import { useSearch } from '@elastic/react-search-ui';
import prevPageIcon from '../../../faceted-search/react/icons/angle-left.svg';
import nextPageIcon from '../../../faceted-search/react/icons/angle-right.svg';
import firstPageIcon from '../../../faceted-search/react/icons/angles-left.svg';
import lastPageIcon from '../../../faceted-search/react/icons/angles-right.svg';
import downIcon from '../../../faceted-search/react/icons/angle-down.svg';
import { PaginationButton } from '../../../faceted-search/react/Pagination';
import { Config } from '../../helper';

export default function OpenSearchPagination() {
  const {
    current,
    totalPages,
    setCurrent,
  } = useSearch();

  if (!totalPages || totalPages <= 1) return null;

  const isFirst = current === 1;
  const isLast = current === totalPages;

  return (
    <div className='faceted-search-pagination'>
      <nav className='pagination'>
        <PaginationButton
          icon={firstPageIcon}
          isDisabled={isFirst}
          onClickHandler={() => setCurrent(1)}
          label={Config.I18n.Pager.FirstPage}/>
        <PaginationButton
          icon={prevPageIcon}
          isDisabled={isFirst}
          onClickHandler={() => setCurrent(current - 1)}
          label={Config.I18n.Pager.PreviousPage}/>
        <div className='pagination__dropdown'>
          <div className='pagination__dropdown-placeholder'>
            <div className='dropdown-placeholder__current-page'>{current}</div>
            <div className='dropdown-placeholder__icon'>
              <img src={downIcon} alt={`Page: ${current}`}/>
            </div>
          </div>
          <label>
            <select value={current} onChange={e => setCurrent(Number(e.target.value))}>
              {Array.from({length: totalPages}, (_, i) => i + 1).map(page => (
                <option key={page} value={page}>
                  {page}
                </option>
              ))}
            </select>
          </label>
        </div>
        <PaginationButton
          icon={nextPageIcon}
          isDisabled={isLast}
          onClickHandler={() => setCurrent(current + 1)}
          label={Config.I18n.Pager.NextPage}/>
        <PaginationButton
          icon={lastPageIcon}
          isDisabled={isLast}
          onClickHandler={() => setCurrent(totalPages)}
          label={Config.I18n.Pager.LastPage}/>
      </nav>
    </div>

  );
}
